var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TransientDataConfig_1;
import '@symon-ai/wisepipe-common'; // force import for JsonSchema
import '@symon-ai/wisepipe-common-connection'; // force import for JsonSchema
import '@symon-ai/wisepipe-common-data'; // force import for JsonSchema
import { DataSource, ImportConfig, ImportConfigType, Origin } from '@symon-ai/wisepipe-common-data';
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
const schema = {
    $id: 'urn:wisepipe-common-computation:TransientDataConfig',
    type: 'object',
    properties: {
        fileLocation: { $ref: 'urn:wisepipe-common:S3File' },
        filePartLocations: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common:S3File' },
            uniqueItems: true
        },
        schema: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:Column' },
            uniqueItems: true
        },
        importConfig: { $ref: 'urn:wisepipe-common-data:ImportConfig' },
        connection: { $ref: 'urn:wisepipe-common-connection:Connection' },
        credentials: { $ref: 'urn:wisepipe-common:Credentials' },
        connID: { type: 'string', uid: 9 },
        streamID: { type: 'string', minLength: 1 },
        delimiter: { type: 'string', minLength: 1 },
        quotechar: { type: 'string', minLength: 1 }
    },
    required: []
};
// File location + schema definition for data coming into a transient run/calc
let TransientDataConfig = TransientDataConfig_1 = class TransientDataConfig {
    constructor(fileLocation, schema, importConfig, connection, credentials, connID, streamID, delimiter, quotechar) {
        this.fileLocation = fileLocation;
        if (schema !== undefined)
            this.schema = schema;
        this.importConfig = importConfig;
        this.connection = connection;
        this.credentials = credentials;
        this.connID = connID;
        this.streamID = streamID;
        // when importConfig is s3csv, use delimiter and quotechar if they are provided
        if (this.importConfig && this.importConfig.importConfigType === ImportConfigType.S3Csv) {
            this.delimiter = delimiter;
            this.quotechar = quotechar;
        }
        // require creds/conn for other types
        if (this.importConfig &&
            ImportConfig.isExternal(this.importConfig.importConfigType) &&
            this.connID === undefined &&
            (this.connection === undefined || this.credentials === undefined)) {
            throw new Error(`Connection and credentials, or a valid connection ID is required for import type: ` +
                this.importConfig.importConfigType);
        }
        JSON.validate(this, TransientDataConfig_1);
    }
    toDataSource(dsID, customSchema = this.schema) {
        return new DataSource(dsID, Origin.newID(), `transient-data:${this.fileLocation.key}`, ImportConfigType.S3Csv, new Date(), this.fileLocation.bucket, this.fileLocation.key, customSchema);
    }
};
TransientDataConfig = TransientDataConfig_1 = __decorate([
    JsonSchema(schema)
], TransientDataConfig);
export { TransientDataConfig };
//# sourceMappingURL=transientDataConfig.js.map